/* eslint-disable eqeqeq */

import React, { useEffect, useRef, useState } from 'react';
import { Grid, Paper, Typography, Button, Box, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { TableComponents, ExportButton, LoadingPage, SimpleDialog, FilterPod, TableItemActionsNew, Icons } from 'components';
import { enifyDateTime } from 'utility';
import { useQuery, useCommon, useCommonDispatcher, useExportFile, useGuildsList } from 'hooks';
import { useStylesColumns } from './style';
import jMoment from 'moment-jalaali';
import { toFilterVOS } from 'components/FilterPod';
import { columns, columnsId } from './Columns';
import { reportInvoiceDebtor, getBusinessCallbackUri } from '../../services/DetailAccountsServices';
import BusinessCallbackUri from '../../BusinessCallbackUri';
import generateData from './generateData';
import { getDialog } from './DialogContents';
import InvoiceServices from '../services/InvoiceServices';
import InitFilters from './InitFiltering';
import createToast from 'components/Toast/Toast';
import useCustomHook from '../hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';
import { getExport1496Url } from 'URLs';
import { useCurrencyUnit } from 'hooks';

// FIXME: Target User Info should be fetched from service instead of url query string

const Content = () => {
  // -- STATES --//
  const {
    targetUserInfo,
    setTargetUserInfo,
    filters,
    setFilters,
    filterParams,
    setFilterParams,
    size,
    setSize,
    isOpenDialog,
    setIsOpenDialog,
    selectedRowData,
    setSelectedRowData,
    actionType,
    setActionType,
    businessCallBackUri,
    setBusinessCallBackUri,
    isOpenDialogCallbackUri,
    setIsOpenDialogCallbackUri,
    isLoading,
    setIsLoading,
    page, setPage,
    loading, setLoading,
    selectedCheckData, setSelectedCheckData

  } = useCustomHook();
  const actionsList =
    getDynamicObjectAction([
      'followersListInvoicesFinancialBtn',
      'invoicListFinancialPage',
      'exportInvoicListFinancialBtn',
      'paymentInvoicListFinancialBtn',
      'detailInvoicListFinancialBtn',
      'closeGroupInvoicListFinancialBtn',
      'operationInvoicListFinancialBtn',
      'invoiceGuildExportBtn',
      'invoiceGuildCallbackBtn',
      'invoiceGuildOperationBtn',
      'invoiceGuildPaymentBtn',
      'invoiceGuildGroupBtn',
      'followersListFinancialExportPage',
      'followersListFinancialPaymentBtn',
      'followersListFinancialOperationBtn',
      'followersListFinancialCallbackBtn',
      'followersListFinancialGroupInvoiceBtn',
      'callbackInvoicListFinancialBtn',
      'invoiceGuildBtn'
    ])
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const matches = useMediaQuery('(max-width:940px)');
  const currencyText = useCurrencyUnit();
  // -- HOOKS --//
  const classes = useStylesColumns();
  const { businessGuildsList, getGuildsList } = useGuildsList();
  const { downloadFile, isExporting } = useExportFile({
    url: getExport1496Url(),
    filename: 'invoice-debtor',
  });
  const navigate = useNavigate();
  const dialog = useCommon();
  const setDialog = useCommonDispatcher();
  const tableRef = useRef();
  const ActionTypes = {
    CANCEL: 'cancel',
    CLOSE: 'close',
  };

  const query = useQuery();
  useEffect(() => {
    if (query) {
      // handle guild id query
      const tempFilters = [...(filters && filters?.length > 0 ? filters : InitFilters(currencyText))];
      const guildCodeQuery = query.get('guild');
      if (guildCodeQuery) {
        const changeTempFilters = tempFilters.find(a => a.id === 1575)
        
        changeTempFilters.disableDelete = true
        updateFilterItem(tempFilters, 'guildId', parseInt(guildCodeQuery));
      }

      // handle default invoiceStatus query
      const invoiceStatusQuery = query.get('invoiceStatus');
      if (invoiceStatusQuery) {
        query.delete('invoiceStatus');
        updateFilterItem(tempFilters, 'status', invoiceStatusQuery);
      }

      // handle start date query
      const startDateQuery = query.get('startDate');
      if (startDateQuery) {
        query.delete('startDate');
        updateFilterItem(tempFilters, 'dateRange', jMoment(startDateQuery, 'jYYYY/jM/jD'), 'start');
      }

      // handle start date query
      const endDateQuery = query.get('endDate');
      if (endDateQuery) {
        query.delete('endDate');
        updateFilterItem(tempFilters, 'dateRange', jMoment(endDateQuery, 'jYYYY/jM/jD'), 'end');
      }

      onFiltersChange([...tempFilters], loading);

      // target user info
      const tUser = {
        userId: query.get('userId'),
        fullName: query.get('fullName'),
        username: query.get('username'),
        image: query.get('image'),
      };
      if (tUser?.image) {
        tUser.image = atob(tUser.image);
      }

      if (tUser?.userId) {
        setTargetUserInfo(tUser);
      }
    }
  }, []);

  useEffect(() => {
    if (actionsList['invoicListFinancialPage']) {
      getGuildsList();
      getCallBackUri();
    }

  }, []);

  useEffect(() => {

    
    if (businessGuildsList?.length === 0) return;
    const tempFilters = [...filters];
    const guildFilterIndex = tempFilters.findIndex((f) => f?.keyName === 'guildId');

    if (guildFilterIndex > 0) {
      tempFilters[guildFilterIndex] = {
        ...tempFilters[guildFilterIndex],
        filterProps: {
          ...tempFilters[guildFilterIndex]?.filterProps,
          options: businessGuildsList,
        },
      };

      onFiltersChange([...tempFilters], true);
      setIsLoading(false);
    }
  }, [businessGuildsList]);

  // -- API REQUESTS --//

  const getList = async (queryParam) => {

    setLoading(true)
    try {
      let orderBy = [];
      const filter = toFilterVOS([...filters]);
  
      const params = {
        page: queryParam ? queryParam?.pageNumber : page,
        size: queryParam ? queryParam?.pageSize : size,
      };

      // ordering
      let orderByName = null;
      if (queryParam?.orderBy?.title) {
        switch (queryParam?.orderBy?.title) {
          case 'تاریخ و زمان صدور':
            orderBy = [
              {
                name: 'تاریخ صدور',
                isDesc: queryParam?.orderDirection === 'desc',
              },
              {
                name: 'زمان صدور',
                isDesc: queryParam?.orderDirection === 'desc',
              },
            ];
            break;
          case 'تاریخ و زمان پرداخت':
            orderBy = [
              {
                name: 'تاریخ پرداخت',
                isDesc: queryParam?.orderDirection === 'desc',
              },
              {
                name: 'زمان پرداخت',
                isDesc: queryParam?.orderDirection === 'desc',
              },
            ];
            break;

          case 'نام حساب تفصیلی کسب‌وکار':
            orderByName = 'نام صنف';
            break;

          case `مالیات (${currencyText})`:
            orderByName = 'مالیات';
            break;

          case `مبلغ قابل پرداخت (${currencyText})`:
            orderByName = 'مبلغ قابل پرداخت';
            break;

          case 'روش پرداخت':
            orderByName = 'نام وسیله پرداخت';
            break;

          default:
            orderByName = queryParam?.orderBy?.title;
            break;
        }
      }
      if (orderByName) {
        orderBy = [
          {
            name: orderByName,
            isDesc: queryParam?.orderDirection === 'desc',
          },
        ];
      }
      // end ordering
      if (query?.size > 0 && (query.get('userId'))) {
        if (targetUserInfo === null) {
          return {
            data: [],
            page: 1,
            totalCount: 0,
          };
        }
      }
      if (targetUserInfo?.userId) {
        filter.push({
          id: columnsId.useId,
          value: targetUserInfo?.userId,
        });
      }

      // final filters data
      const data = {
        filterVOS: filter ?? [],
        orderByElementVOS: orderBy ?? [],
        parentParams: [
          {
            key: 'START_DATE',
            value: enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD HH:mm:ss')),
          },
          {
            key: 'END_DATE',
            value: enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD HH:mm:ss')),
          },
        ],
      };
      if (!data.filterVOS.find(a => a.id === "1575")) {
          if (query.get("guild")) {
            data.filterVOS.push({id:"1575" , value:query.get("guild") , key:'guildId'})
          }
      }
      setFilterParams({ data, params });
      const res = await reportInvoiceDebtor(data, params);

      let list = [];

      if (res.result.rows) {
        list = generateData(res.result.rows, {
          page: queryParam ? queryParam?.pageNumber : page,
          pageSize: queryParam ? queryParam?.pageSize : page,
        });
      }
      setIsLoading(false)
      setLoading(false)
      return {
        data: list,
        page: queryParam ? queryParam?.pageNumber : page,
        totalCount: res.result.totalCount,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setIsLoading(true)
        setLoading(true)
      } else {
        if (axios.isAxiosError(error)) {
          setIsLoading(false)
          setLoading(false)
          return {
            data: [],
            page: queryParam ? queryParam?.pageNumber : page,
            totalCount: 0,
          };
        }
      }
    }
  };


  const getCallBackUri = async () => {
    try {
      const res = await getBusinessCallbackUri({ active: true });
      setBusinessCallBackUri(res.result);
    } catch (error) { }
  };

  const sendSms = async (rowData) => {
    createToast('در انتظار', 'در حال ارسال پیامک', 'info');
    try {
      await InvoiceServices.sendInvoicePaymentSms(rowData.invoiceId);
      createToast('موفق', 'با موفقیت انجام شد', 'success');
    } catch (error) { }
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters, isFirstCall) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    if (!isFirstCall) {
      setTimeout(() => {
        tableRef?.current?.onChangeTable(true);
      }, 100)
    }
  };

  const updateFilterItem = (
    inputFilters = [], // this method changes the source array, do not pass the state!!
    filterIDorKeyName,
    newValue,
    targetValueKey,
  ) => {
    if (!filterIDorKeyName) return inputFilters;
    const filterIndex = inputFilters.findIndex(
      (f) => f.id == filterIDorKeyName || f.keyName == filterIDorKeyName,
    );
    if (filterIndex < 0) return inputFilters;
    if (!targetValueKey) {
      inputFilters[filterIndex] = { ...inputFilters[filterIndex], value: newValue };
    } else if (targetValueKey === 'start') {
      inputFilters[filterIndex] = {
        ...inputFilters[filterIndex],
        value: { ...inputFilters[filterIndex]?.value, start: newValue },
      };
    } else if (targetValueKey === 'end') {
      inputFilters[filterIndex] = {
        ...inputFilters[filterIndex],
        value: { ...inputFilters[filterIndex]?.value, end: newValue },
      };
    }
    return inputFilters;
  };

  const handleCloseDialog = () => {
    setDialog({ title: '', content: '', open: false });
  };

  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };

  const onRemoveTargetUser = async () => {
    setTargetUserInfo(null);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
    if (query) {
      query.delete('username');
      query.delete('userId');
      query.delete('fullName');
      query.delete('image');
    }
  };

  const handleClick = (rd, actionType) => {
    setActionType(actionType);
    setSelectedRowData(rd);
    setIsOpenDialog(true);
  };

  // TODO: Check the situation where targetUser is available
  return (
    <>
      <Grid container spacing={0}>

        <Grid item xs={12}>
          {isLoading ? (
            <LoadingPage />
          ) : (
            <>
              {targetUserInfo?.userId ? (
                <Grid container justifyContent="space-between" className={classes.toolbar}>
                  <Grid item>
                    <TargetUser
                      classes={classes}
                      targetUserInfo={targetUserInfo}
                      onRemove={onRemoveTargetUser}
                    />
                  </Grid>
                </Grid>
              ) : null}

              <Grid item xs={12}>
                <Box display='flex' justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16, gap: matches ? '5px' : '0' }} className={classes.btnActions}>
                  {(actionsList['invoicListFinancialPage'] || actionsList['followersListInvoicesFinancialBtn'] || actionsList['invoiceGuildBtn']) && (
                    <FilterButton
                      setOpenFilterDialog={setOpenFilterDialog}
                      filters={filters}
                    />
                  )}
                  {(actionsList['invoiceGuildCallbackBtn'] || actionsList['followersListFinancialCallbackBtn'] || actionsList['callbackInvoicListFinancialBtn']) && (
                    <Button
                      onClick={() => setIsOpenDialogCallbackUri(true)}
                      variant="outlined"
                      color="primary"
                      style={{ minWidth: matches ? '100%' : '200px', margin: matches ? '0' : '0 5px' }}
                    >
                      آدرس‌های بازگشت
                    </Button>
                  )}
                  {(actionsList['followersListFinancialExportPage'] || actionsList['exportInvoicListFinancialBtn'] || actionsList['invoiceGuildExportBtn']) && (
                    <ExportButton
                      loading={isExporting}
                      types={['xls', 'csv']}
                      onExport={onExport}
                    />
                  )}
                </Box>
                {(actionsList['invoicListFinancialPage'] || actionsList['followersListInvoicesFinancialBtn'] || actionsList['invoiceGuildBtn']) && (
                  <Box>
                    <FilterPod
                      filters={filters}
                      onChange={onFiltersChange}
                      openFilterDialog={openFilterDialog}
                      setOpenFilterDialog={setOpenFilterDialog}
                      handleCloseFilterDialog={handleCloseFilterDialog}
                    />
                  </Box>
                )}
              </Grid>
              {(actionsList['invoicListFinancialPage'] || actionsList['followersListInvoicesFinancialBtn'] || actionsList['invoiceGuildBtn'])&& currencyText && (

                <TableComponents
                  data={getList}
                  columns={columns(navigate, sendSms, handleClick, actionsList , currencyText)}
                  isLoading={loading}
                  ref={tableRef}
                  selectionOptions={{
                    hasCheckbox: true,
                    seletedCheckData: setSelectedCheckData
                  }}
                  onChange={(ps) => {
                    setPage(ps?.pageNumber)
                    setSize(ps?.pageSize)
                    return getList(ps)
                  }}
                  checkBoxAction={[
                    ...((actionsList['closeGroupInvoicListFinancialBtn'] ||
                      actionsList['followersListFinancialGroupInvoiceBtn'] || actionsList['invoiceGuildGroupBtn']) ? [
                      () => ({
                        isFreeAction: true,
                        icon: () => (
                          <TableItemActionsNew
                            startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
                            title="عملیات گروهی"
                            otherMenus={[
                              {
                                title: 'کنسل کردن گروهی',
                                isShow: true,
                                onClick: () => {
                                  handleClick(selectedCheckData, ActionTypes.CANCEL);
                                },
                              },
                              {
                                title: ' بستن گروهی',
                                isShow: true,
                                onClick: () => {
                                  handleClick(selectedCheckData, ActionTypes.CLOSE);
                                },
                              },
                            ]}
                          />
                        ),
                      }),
                    ] : [])
                  ]}

                />
              )}


            </>
          )}
        </Grid>

      </Grid>

      <SimpleDialog
        fullWidth
        maxWidth="md"
        open={isOpenDialogCallbackUri}
        title="آدرس‌های بازگشت"
        onClose={() => setIsOpenDialogCallbackUri(false)}
      >
        <BusinessCallbackUri data={businessCallBackUri} />
      </SimpleDialog>

      <SimpleDialog
        fullWidth
        maxWidth="lg"
        open={dialog?.open || false}
        title={dialog?.title}
        onClose={handleCloseDialog}
        loading={dialog?.loading || false}
      >
        {dialog?.content}
      </SimpleDialog>
      {
        getDialog(
          actionType,
          selectedRowData,
          setIsOpenDialog,
          isOpenDialog,
          tableRef,
          businessCallBackUri,
        )
      }
    </>
  );
};

const TargetUser = ({ classes, targetUserInfo, onRemove }) => {
  return (
    <Grid container>
      <Paper className={classes.targetUser}>
        <Grid container alignItems="center" className={classes.targetContainer}>
          <Grid item>
            <Grid container className={classes.contentUser}>
              {targetUserInfo?.fullName ? (
                <Typography className={classes.targetFullName}>
                  {targetUserInfo?.fullName}
                </Typography>
              ) : null}
              {targetUserInfo?.username ? (
                <Typography className={classes.targetUsername}>
                  {targetUserInfo.username}
                </Typography>
              ) : null}
              {targetUserInfo?.userId ? (
                <Typography className={classes.targetId}>
                  {targetUserInfo?.username || targetUserInfo?.fullName ? (
                    <div className={classes.dot} />
                  ) : null}
                  شناسه کاربر :‌ {` ${targetUserInfo.userId}`}
                </Typography>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default Content;